import { ItemDiscount } from 'apis/restaurant-api/merchant-admin/campaigns/api';
import { convertDecimalToMonetaryInt } from 'common/utils/currencyDecimals';

import { TransformItemDiscountFormToApiValues } from './transformFormToApi/transformItemDiscountFormToApi';
import { ItemDiscountType } from '../types';

export const getItemDiscount = (values: TransformItemDiscountFormToApiValues): ItemDiscount => {
  const items = values.isMultiItemCampaignSupported
    ? {
        items: values.itemIds.length
          ? // No support for multi-venue item campaigns yet
            values.venueIds.map(venueId => ({
              itemIds: values.itemIds,
              venueId,
            }))
          : [],
        categories: values.categoryIds.length
          ? values.venueIds.map(venueId => ({
              categoryIds: values.categoryIds,
              venueId,
            }))
          : [],
      }
    : {};

  const common = {
    ...items,
    targetItem: {
      itemId: values.itemIds[0],
      venueId: values.venueIds[0],
    },
    itemTriggerCount: values.itemTriggerCount,
  };

  if (values.discountType === ItemDiscountType.AMOUNT_OFF) {
    return {
      ...common,
      amount: values.amount ? convertDecimalToMonetaryInt(values.amount, values.currency) : 0,
      percentage: null,
      freeItemsCount: null,
    };
  }

  if (values.discountType === ItemDiscountType.PERCENTAGE_OFF) {
    return {
      ...common,
      amount: null,
      percentage: values.percentage || 0,
      freeItemsCount: null,
    };
  }

  return {
    ...common,
    amount: null,
    percentage: null,
    freeItemsCount: values.freeItemsCount || 0,
  };
};
